module.exports = __webpack_public_path__ + "static/media/oval-login2.65802963.svg";